import { render, staticRenderFns } from "./RedPackageYu.vue?vue&type=template&id=4be94747&"
import script from "./RedPackageYu.vue?vue&type=script&lang=js&"
export * from "./RedPackageYu.vue?vue&type=script&lang=js&"
import style0 from "./RedPackageYu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports